import { z } from 'zod';
// ── Reusable primitives ───────────────────────────────────────────────────────
/**
 * Validates a Salesforce org alias: 1-80 characters, letters / digits / _ / -.
 * Spaces and special characters are not allowed by the SF CLI.
 */
const orgAliasSchema = z
    .string()
    .min(1, 'Org alias must not be empty')
    .max(80, 'Org alias must not exceed 80 characters')
    .regex(/^[a-zA-Z0-9_-]+$/, 'Org alias may only contain letters, digits, underscores, and hyphens');
// ── CreateDeploymentSchema ────────────────────────────────────────────────────
export const CreateDeploymentSchema = z
    .object({
    deploymentType: z.enum(['arm', 'vlocity']),
    sourceOrg: orgAliasSchema,
    targetOrg: orgAliasSchema,
    entities: z
        .array(z.string().min(1, 'Entity name must not be empty'))
        .min(1, 'At least one entity is required'),
    initiatedBy: z.string().min(1, 'initiatedBy must not be empty'),
})
    .refine((data) => data.sourceOrg !== data.targetOrg, {
    message: 'sourceOrg and targetOrg must be different orgs',
    path: ['targetOrg'],
});
//# sourceMappingURL=deployment.js.map